export default __webpack_public_path__ + "static/media/loading.c7d9f081.gif";